import { render, staticRenderFns } from "./AdminTariffPage.vue?vue&type=template&id=b05a05c6&scoped=true&"
import script from "./AdminTariffPage.vue?vue&type=script&lang=js&"
export * from "./AdminTariffPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05a05c6",
  null
  
)

export default component.exports